import React from "react";
import { AnchorLink } from "gatsby-plugin-anchor-links";

// Import styles
import "./styles/intro.scss";

// Import video
import video from "../assets/videos/intro.mp4";

// Import icons
import { AiOutlineDown } from "react-icons/ai";

// Import bootstrap
import { Button, Container } from "react-bootstrap";

const Intro = () => {
  return (
    <section className="intro">
      <video className="video fade-in-slow" playsInline autoPlay muted loop>
        <source src={video} type="video/mp4" />
      </video>
      <div className="content">
        <Container className="text fade-in-slow">
          <div className="shout sentence">
            <div className="slidingVertical">
              <span>You got this.</span>
              <span>
                You are one with
                <br /> the universe.
              </span>
              <span>
                Please yourself,
                <br /> not others.
              </span>
              <span>
                Your mistakes do not
                <br /> define you.
              </span>
              <span>Listen to your gut.</span>
            </div>
          </div>
          <AnchorLink
            to="/#the-shop"
            title="Check out my products!"
            className="stripped scroll-down talk"
            stripHash
          >
            View Products
            <br />
            <AiOutlineDown />
          </AnchorLink>
        </Container>
      </div>
    </section>
  );
};

export default Intro;
